import { IconName } from '/components/blocks/menu-icon/menu-icon';

export enum HeaderItemType {
  IconButton = 'ICON_BUTTON',
  LanguageSelector = 'LANGUAGE_SELECTOR',
  IconTextButton = 'ICON_TEXT_BUTTON',
  IconDropdownMenu = 'ICON_DROPDOWN_MENU',
  IconTextButtonDropdown = 'ICON_TEXT_BUTTON_DROPDOWN',
  AppSwitcher = 'APP_SWITCHER',
}

interface HeaderItemBase {
  id: string;
  type: HeaderItemType;
  ariaLabel?: string;
}

export interface IconButtonHeaderItem extends HeaderItemBase {
  type: HeaderItemType.IconButton;
  iconName: IconName;
  onClick?: () => void;
}

export interface LanguageSelectorHeaderItem extends HeaderItemBase {
  type: HeaderItemType.LanguageSelector;
}
export interface AppSwitcherHeaderItem extends HeaderItemBase {
  type: HeaderItemType.AppSwitcher;
}

export interface IconTextButtonHeaderItem extends HeaderItemBase {
  type: HeaderItemType.IconTextButton;
  iconName: IconName;
  text: string;
  onClick?: () => void;
}

export interface DropdownOption {
  id: string;
  icon: IconName;
  text: string;
  iconColor?: string;
  textColor?: string;
  callback: () => void;
}

export interface IconDropdownMenuHeaderItem extends HeaderItemBase {
  type: HeaderItemType.IconDropdownMenu;
  triggerIconName: IconName;
  options: DropdownOption[];
}

export interface IconTextButtonDropdownHeaderItem extends HeaderItemBase {
  type: HeaderItemType.IconTextButtonDropdown;
  triggerIconName: IconName;
  text: string;
  options: DropdownOption[];
}

export type HeaderItem =
  | IconButtonHeaderItem
  | LanguageSelectorHeaderItem
  | IconTextButtonHeaderItem
  | IconDropdownMenuHeaderItem
  | IconTextButtonDropdownHeaderItem
  | AppSwitcherHeaderItem;
